module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/wechat-code.0db56ac7.png";